import React from 'react';
import { SwitchGroup } from '@/components/atoms/SwitchGroup';
import { LoyaltyFeature } from '@/services/innovorder/modules/modules.type';

interface LoyaltyFeaturesProps {
    features: LoyaltyFeature[];
    onChange: (features: LoyaltyFeature[]) => void;
}

const LoyaltyFeatures: React.FC<LoyaltyFeaturesProps> = ({ features, onChange }) => {
    const handleChange = (value: Record<string, boolean>) => {
        const updatedFeatures = features.map((feature) => ({
            ...feature,
            isEnabled: value[feature.id.toString()],
        }));
        onChange(updatedFeatures);
    };

    const switchOptions = features.map((feature) => ({
        labelId: `loyalty.features.${feature.name}`,
        name: feature.id.toString(),
        value: feature.isEnabled,
        disabled: true,
    }));

    return (
        <div>
            <SwitchGroup
                labelId="loyalty.features.title"
                options={switchOptions}
                value={Object.fromEntries(features.map((f) => [f.id.toString(), f.isEnabled]))}
                onChange={handleChange}
            />
        </div>
    );
};

export default LoyaltyFeatures;
